import styled from 'styled-components'

export const DashboardAccessPanel = styled.div`
  min-width: 0;
  background: var(--role-surface, #fff);
  color: var(--role-text, #202124);

  .access-explanation {
    border-top: 1px solid var(--role-border, #e0e0e0);
    padding: 14px 0 0;
    color: var(--role-text-secondary, #8f8f8f);
    font-size: 12px;
  }
  .access-alert {
    margin: 0 0 16px;
  }
  .access-columns,
  .access-row {
    display: grid;
    grid-template-columns: minmax(0, 1fr) 106px;
    align-items: center;
    gap: 14px;
  }
  .access-columns {
    padding: 8px 16px;
    background: var(--role-fill, #fafafa);
    border-top: 1px solid var(--role-border, #e0e0e0);
    color: var(--role-text-secondary, #8f8f8f);
    font-size: 12px;
  }
  .access-list {
    min-height: 48px;
  }
  .access-group + .access-group {
    border-top: 1px solid var(--role-border, #e0e0e0);
  }
  .access-row {
    min-height: 48px;
    padding: 7px 16px;
    transition: background 140ms ease;
  }
  .access-row:hover,
  .access-group.is-expanded > .access-row {
    background: var(--role-fill, #fafafa);
  }
  .access-group-name {
    display: flex;
    align-items: center;
    gap: 10px;
    min-width: 0;
  }
  .access-expand,
  .access-group-title,
  .access-future {
    border: 0;
    background: transparent;
    color: inherit;
    cursor: pointer;
  }
  .access-expand {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    width: 24px;
    height: 30px;
    flex-shrink: 0;
    color: var(--role-text-secondary, #8f8f8f);
  }
  .access-expand .anticon {
    transition: transform 140ms ease;
    font-size: 11px;
  }
  .is-expanded > .access-row .access-expand .anticon {
    transform: rotate(90deg);
  }
  .access-group-title {
    flex: 1;
    min-width: 0;
    padding: 4px 0;
    text-align: left;
    font-size: 15px;
    font-weight: 600;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .access-expand:focus-visible,
  .access-group-title:focus-visible,
  .access-future:focus-visible {
    outline: 2px solid var(--role-accent, var(--system-focus, #1677ff));
    outline-offset: 2px;
    border-radius: 3px;
  }
  .access-expand:disabled,
  .access-group-title:disabled {
    cursor: default;
  }
  .access-count {
    display: flex;
    align-items: center;
    gap: 8px;
    color: var(--role-text-secondary, #8f8f8f);
    font-size: 13px;
    font-variant-numeric: tabular-nums;
    white-space: nowrap;
  }
  .access-future,
  .access-future-placeholder {
    display: inline-flex;
    width: 18px;
    flex-shrink: 0;
  }
  .access-future {
    padding: 0;
    font-size: 15px;
    color: var(--role-text-secondary, #8f8f8f);
  }
  .access-indicators {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 8px 24px;
    padding: 12px 24px 16px 62px;
    border-top: 1px solid var(--role-border, #e0e0e0);
  }
  .access-indicators .ant-checkbox-wrapper {
    display: flex;
    align-items: flex-start;
    margin: 0;
    min-width: 0;
    padding: 3px 0;
    line-height: 20px;
  }
  .access-indicators .ant-checkbox {
    margin-top: 2px;
  }
  .access-indicators .ant-checkbox + span {
    overflow-wrap: anywhere;
  }
  .access-empty {
    padding: 28px 18px;
    color: var(--role-text-secondary, #8f8f8f);
    text-align: center;
  }
  .access-empty p {
    margin: 0 0 10px;
  }

  @media (max-width: 640px) {
    .access-columns {
      display: none;
    }
    .access-row {
      grid-template-columns: minmax(0, 1fr) 94px;
      gap: 2px 8px;
      padding: 8px 12px;
    }
    .access-group-name {
      gap: 6px;
    }
    .access-group-title {
      font-size: 14px;
    }
    .access-count {
      justify-content: flex-end;
      font-size: 12px;
    }
    .access-indicators {
      grid-template-columns: minmax(0, 1fr);
      padding: 10px 16px 14px 44px;
      gap: 4px;
    }
    .access-alert {
      margin: 0 0 16px;
    }
  }

  @media (prefers-reduced-motion: reduce) {
    .access-row,
    .access-expand .anticon {
      transition: none;
    }
  }
`
